import xss from 'xss'

import { Radio, RadioGroup } from '@wartek-id/radio'
import { Text } from '@wartek-id/text-v1'

import type { FC } from 'react'
import type { IUjikomQuestionQuestion } from 'types/content-platform'

interface QuestionCardProps extends IUjikomQuestionQuestion {
  getInputName: Function
  register: Function
}

const QuestionCard: FC<QuestionCardProps> = ({
  body,
  choices,
  getInputName,
  register,
  position,
  id,
}) => {
  return (
    <div className="rounded-lg bg-white m-4 px-4 pt-4 pb-5 flex flex-col space-y-5">
      <Text variant="body" dangerouslySetInnerHTML={{ __html: xss(body) }} />
      <RadioGroup name={getInputName(id)} className="flex-col space-y-3">
        {choices.map((thisChoice) => (
          <Radio
            {...register(getInputName(id), { required: position })}
            key={`${id}_${thisChoice.id}`}
            value={thisChoice.id}
            labelPosition="center"
            className="capitalize-words"
          >
            {thisChoice.body}
          </Radio>
        ))}
      </RadioGroup>
    </div>
  )
}

export default QuestionCard
